import _ from "underscore";
// Since our UNLIMITED and UPDATE memberships are on difference platforms
// we have different fields and ways to access our items
// This helper should standardize how we get information from our atHomeItems (UNLIMITED) and membershipItems (UPDATE/NEW UNLIMITED)
import ProductImagePath from "helpers/product-image-path.js";
import MembershipHelpers from "helpers/membership-helpers";
import Constants from "../constants.js";
import { ProductImageOrientation, ProductImageSize } from "./product-image-helpers";

var MembershipItemsHelpers = {
  getBookingId: function (item = {}, membershipState = {}) {
    const bookingId = MembershipHelpers.isActiveMembership(membershipState) ? item.bookingId : item.id;
    return bookingId;
  },

  getImgSrc: function (item = {}, membershipState = {}) {
    if (MembershipHelpers.isActiveMembership(membershipState)) {
      return item?.imgSrc;
    }

    const frontimage = item?.product?.images?.[ProductImageOrientation.FRONT.path];
    return ProductImagePath + frontimage?.[ProductImageSize.x70.path];
  },

  isAvailableForUpdate: function (item = {}) {
    return _.includes(item.eligibleFor, Constants.membershipNamesEligibleFor.RTRUpdate);
  },

  isAvailableForUnlimited: function (item = {}) {
    return _.includes(item.eligibleFor, Constants.membershipNamesEligibleFor.RTRUnlimited);
  },

  isAvailableForReserve: function (item = {}) {
    return _.includes(item.eligibleFor, Constants.membershipNamesEligibleFor.RTRReserve);
  },
};

export default MembershipItemsHelpers;

export const { getBookingId, getImgSrc, isAvailableForUpdate, isAvailableForUnlimited, isAvailableForReserve } =
  MembershipItemsHelpers;
